module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/显微镜模组.17f08bac.png";